ApplicationSerializer = require './application'

module.exports = App.ClientTagSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    consumed_category:
      serialize: 'ids'
    consumed_dish:
      serialize: 'ids'
    non_consumed_category:
      serialize: 'ids'
    non_consumed_dish:
      serialize: 'ids'
    tags_to_unassign:
      serialize: 'ids'
